import * as React from 'react';
import { Link, graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import Layout from '../components/layout';
import Seo from '../components/seo';
import HomePageHeroSection from '../components/pages-component/home-page/HomePageHeroSection';
import RemoteCompanyIncorporation from '../components/pages-component/home-page/RemoteCompanyIncorporation';
import '../styles/pages/homepage.scss';
import SecuredDashboard from '../components/pages-component/home-page/SecuredDashboard';
import TrustPilotReviews from '../components/common/TrustpilotReviews';
import BusinessRegistrationProces from '../components/pages-component/home-page/BusinessRegistrationProces';
import WhyAirCorporate from '../components/pages-component/home-page/WhyAirCorporate';
import FAQSection from '../components/common/FaqSection';
import Industry from '../components/pages-component/home-page/Industry';
import ReviewsCarousel from '../components/common/ReviewsCarousel';
import OurBlogs from '../components/common/OurBlogs';
import Cta from '../components/common/Cta';
import { COLORS } from '../constants/enum';
const HomePageTemplate = ({ data, location }) => {
  const { title, faqs, our_blog, linked_cta } = data?.prismicHomePage?.data || {};
  const { reviews } = data?.prismicTrustpilotReviews?.data || {};

  return (
    <Layout
      logosColor={COLORS?.WHITE}
      headerBgColor="bg-blue-400"
      headerContainer="hompage-header-container"
      HeaderComponent={<HomePageHeroSection />}
    >
      <TrustPilotReviews reviews={reviews} />
      <RemoteCompanyIncorporation />

      <div className="global-max-width-wrapper mx-auto">
        {/* prismic title - {`${title?.text}`}
        <ol style={{ listStyle: `none` }}>
          {blogList.map((post) => {
            const title = post.data.title.text;

            return (
              <li key={post.uid}>
                <article className="post-list-item" itemScope itemType="http://schema.org/Article">
                  <header>
                    <h2>
                      <Link to={post.url} itemProp="url">
                        <span itemProp="headline">{title}</span>
                      </Link>
                    </h2>
                    <small>{post.data.date_posted}</small>
                    <p>{post.data.excerpt}</p>
                  </header>
                </article>
              </li>
            );
          })}
        </ol> */}
      </div>
      <SecuredDashboard />
      <BusinessRegistrationProces />
      <WhyAirCorporate />
      <FAQSection faqData={faqs} />
      <OurBlogs our_blog={our_blog} />
      <Cta
        title={linked_cta?.document?.data?.title?.text}
        description={linked_cta?.document?.data?.description?.html}
        buttonCaption={linked_cta?.document?.data?.button_caption?.text}
        buttonLink={linked_cta?.document?.data?.button_link?.text}
        contentUrl={linked_cta?.document?.data?.content_url?.text}
      />
      <Industry />
      <ReviewsCarousel
        title="They succeeded with Air Corporate"
        subtitle="Trusted by 1,000+ entrepreneurs and SMEs"
        bgColor="bg-yellow-200"
        carouselData={data?.allPrismicReviewsCarousel?.nodes[0]?.data?.review}
      />
    </Layout>
  );
};

export const Head = ({ data }) => {
  const { seo_title, seo_description } = data?.prismicHomePage?.data || {};
  return <Seo title={seo_title?.text} description={seo_description?.text} />;
};

export const homePageQuery = graphql`
  query HomePageQuery {
    prismicHomePage {
      _previewable
      data {
        title {
          text
        }
        faqs {
          answer {
            html
          }
          question {
            text
          }
        }
        our_blog {
          linked_blog {
            document {
              ... on PrismicPost {
                uid
                data {
                  description {
                    text
                  }
                  title {
                    text
                  }
                  image {
                    url
                    alt
                  }
                }
              }
            }
          }
        }
        linked_cta {
          document {
            ... on PrismicCta {
              data {
                button_caption {
                  text
                }
                button_link {
                  text
                }
                description {
                  html
                }
                title {
                  text
                }
                content_url {
                  text
                }
              }
            }
          }
        }
        seo_title {
          text
        }
        seo_description {
          text
        }
      }
    }
    prismicTrustpilotReviews {
      data {
        reviews {
          description {
            text
          }
          review_date
          reviewer_name {
            text
          }
          title {
            text
          }
        }
      }
    }
    allPrismicReviewsCarousel {
      nodes {
        data {
          review {
            description {
              text
            }
            photo {
              url
            }
            rating
            reviewer_details {
              text
            }
            reviewer_name {
              text
            }
          }
        }
      }
    }
  }
`;

export default withPrismicPreview(HomePageTemplate);
